/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, type ReactNode, createContext, forwardRef } from 'react';
import { Collection, type ContextValue, DEFAULT_SLOT, Provider, ToggleButton as ToggleButtonCore, type ToggleButtonProps as ToggleButtonCoreProps, useContextProps } from 'react-aria-components';
import { $ } from '../../tokens.stylex';
import { Text, TextContext } from '../text/text.component';

interface ReactionToggleButtonProps<T extends object = object> extends Omit<ToggleButtonCoreProps, 'className' | 'style' | 'children'> {
  /** Item objects in the collection. */
  items?: Iterable<T>;
  style?: stylex.StyleXStyles;
  children?: ReactNode | ((item: T) => ReactNode);
}

const ReactionToggleButtonContext = createContext<ContextValue<ReactionToggleButtonProps, HTMLButtonElement>>({});

const ReactionToggleButton = forwardRef((props: ReactionToggleButtonProps, ref: ForwardedRef<HTMLButtonElement>) => {
  [props, ref] = useContextProps(props, ref, ReactionToggleButtonContext);

  const { style, items, children, ...coreProps } = props;

  const itemsArray = Array.from(items ?? []);

  return (
    <ToggleButtonCore
      ref={ref}
      {...stylex.props(styles.base, style)}
      {...coreProps}>
      {(renderProps) => (
        <Provider values={[
          [TextContext, {
            slots: {
              [DEFAULT_SLOT]: {
                size: 14,
                weight: 'semibold',
              },
              [REACTION_TOGGLE_BUTTON_SLOTS.TOTAL_COUNT_TEXT]: {
                size: 12,
                weight: 'medium',
                color: renderProps.isSelected ? 'white' : 'tertiary',
              }
            }
          }],
        ]}>
          {typeof children === 'function'
            ? (
              <>
                <Collection items={items}>{children}</Collection>
                {itemsArray.length > 0 && <Text slot={REACTION_TOGGLE_BUTTON_SLOTS.TOTAL_COUNT_TEXT}>{itemsArray.length}</Text>}
              </>
            )
            : children}
        </Provider>
      )}
    </ToggleButtonCore>
  );
}) as <T extends object>(props: ReactionToggleButtonProps<T> & { ref?: ForwardedRef<HTMLButtonElement> }) => React.ReactElement;

const styles = stylex.create({
  base: {
    borderColor: {
      default: $.borderContrastInverted,
      ':is([data-hovered])': $.borderInteractive,
      ':is([data-selected])': $.borderContrastInverted,
    },
    borderRadius: 100,
    borderStyle: 'solid',
    borderWidth: 2,
    gap: 4,
    paddingBlock: 4,
    alignItems: 'center',
    backgroundColor: {
      default: $.surfaceBGSecondary,
      ':is([data-selected])': $.surfaceHighlight,
    },
    cursor: {
      default: 'pointer',
      ':is([data-disabled])': 'default',
      ':is([data-pending])': 'wait',
    },
    display: 'inline-flex',
    transitionDuration: '0.2s',
    transitionProperty: 'color, background-color, border',
    transitionTimingFunction: 'easy-in-out',
    paddingLeft: 8,
    paddingRight: 8,
  },
});

const REACTION_TOGGLE_BUTTON_SLOTS = {
  TOTAL_COUNT_TEXT: 'total-count-text',
};

export { REACTION_TOGGLE_BUTTON_SLOTS, ReactionToggleButton, ReactionToggleButtonContext, type ReactionToggleButtonProps };
